import React, { useEffect } from 'react';
import { track } from '@amplitude/analytics-browser';
import { Link } from '@nimbus-ds/components';
import { ExternalLinkIcon, MoneyIcon } from '@nimbus-ds/icons';
import { CalloutCard } from '@nimbus-ds/patterns';
import { useBankAccount, useStoreInfo } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import { LENDING_EXTERNAL_URL } from '../consts';

function ActiveContractBanner(): JSX.Element {
  const { t } = useTranslationWithPrefix('home.activeContractBanner');
  const { data: bankAccount } = useBankAccount();
  const { storeInfo } = useStoreInfo();
  const personId = storeInfo.user?.id;

  useEffect(() => {
    track('pagonube_lending_contracts_payments_view', { person_id: personId });
  }, [personId]);

  const handleLinkClick = () => {
    const cuit = bankAccount?.fiscalDocument;
    const url = new URL(LENDING_EXTERNAL_URL);
    if (cuit) url.searchParams.set('document_id', cuit);
    const panelUrl = url.toString();
    track('pagonube_lending_contracts_payments_click', { person_id: personId });
    window.open(panelUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <CalloutCard
      data-testid="active-contract-banner"
      appearance="neutral"
      icon={MoneyIcon}
      title={t('title')}
      subtitle={t('subtitle')}
      link={
        <Link
          appearance="primary"
          fontSize="caption"
          textDecoration="none"
          onClick={handleLinkClick}
        >
          {t('link')}
          <ExternalLinkIcon size="small" />
        </Link>
      }
    />
  );
}

export default ActiveContractBanner;
